import { Injectable ,InjectionToken} from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { IAppConfig } from '../../Model/config.model'
// import data from 'src/assets/config/config.json';
import {firstValueFrom,  Observable } from 'rxjs';




@Injectable({
  providedIn: 'root'
})


export class ConfigLoaderService {
  // public environment = "";
  // //For testing Purpose
  // public projectId = '';
  // public apiURL = "";

  // public copyRight = "";
  // public hanaLink = "";
  // public eccLink = "";
  // public bwLink = "";
  // public apoLink = "";
  // public srmLink = "";
  // public utilitiesLink = "";
  // public upstreamLink = "";
  // public downstreamLink = "";
  // public demoLink = '';


 
  private http: HttpClient;
  static settings: IAppConfig;
  public appsetting!:any[];
  private endpoint!: string;


  public clientId!:string;

  constructor(
    private httpClient: HttpClient,
    private readonly httpHandler: HttpBackend,
    ) {
    this.http = new HttpClient(httpHandler);
    
  }



initialize(): Promise<IAppConfig> {
  return firstValueFrom(
    this.httpClient.get<IAppConfig>('./assets/config/config.json')
      .pipe(
        tap((response: IAppConfig) => {
          this.clientId = response.adalConfig.clientId;
          ConfigLoaderService.settings = response;
        })
      )
  );
}


init(): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    const endpoint = './assets/config/config.json';
    this.http.get(endpoint)
      .pipe(map(res => res))
      .subscribe({
        next: (value: any) => {
          const environment = (value?.env?.name || '').toUpperCase();
          if (environment !== 'DEVELOPMENT') {
            this.appsetting = value['adalConfig'];
          }
          ConfigLoaderService.settings = value as IAppConfig;
          resolve(true);
        },
        error: (err: any) => {
          console.error('Config loading failed:', err);
          reject(err);
        }
      });
  });
}

  getSettings(key?: string | Array<string>, configValues?:any): any {
  
  
    if (!key || (Array.isArray(key) && !key[0])) {
     
      return this.appsetting;
    }
    if (!Array.isArray(key)) {
      key = key.split('.');
      
    }

    // if(this.appsetting=="undefined" ||this.appsetting==undefined){
    //   console.log('hereh11')
    //   this.endpoint='./assets/config/config.json';
    //   this.http.get(this.endpoint).pipe(map(res => res))
    //     .subscribe(value => {  
    //      // adalConfigValue=value;
    //      console.log('hhhhh')
    //       this.appsetting=value
    //     });

    // }
 
   
     
    
     let result = key.reduce((acc: any, current: string) => acc && acc[current], this.appsetting);
    // console.log(result);
    return result;
  }


  getConfiguration() {
    return this.httpClient.get('./assets/config/config.json')
    }
}
  






